<template>
  <v-container>
    <v-layout row wrap>
      <v-flex md12>
          <p class="headline mt-3">
              Estados de contención de carteras
          </p>
      </v-flex>

      <v-flex md5>
        <div class="d-inline pa-2">
            <p class="headline mt-3">
                Día de mora
                <v-btn class="btn--edit" small @click.prevent="openDialogDeliquency()">
                    Editar
                </v-btn>
            </p>
        </div>

        <Edit 
            :dialog="dialog" 
            :title="info.title" 
            @closeModal="closeDialog"
            @updateDeliquency="updateDeliquency"
            @updatetranches="updateTranche"
            />
          

        <v-card class="raised">
            <v-card-text>
              <v-layout :class="`${delinquency.id < 4 ? 'border--bottom' : 'margin--bottom' }`" 
                  row wrap v-for="delinquency in delinquency_status" :key="delinquency.id">
                <v-flex class="subtitle" md4 pr-3>
                  <strong>
                    {{ delinquency.delinquency_status }}
                  </strong>
                </v-flex>
                <v-flex class="subtitle indicator" md3 style="text-align: center;">
                    >
                </v-flex>
                <v-flex class="subtitle value" md4>
                  <div>
                    <div>
                      {{ delinquency.mask != null ? delinquency.mask : delinquency.delinquency_status }}
                    </div>  
                  </div>
                </v-flex>
              </v-layout>
            </v-card-text>
        </v-card>
      </v-flex>

      <v-flex md2></v-flex>

      <v-flex md5>
        <div class="d-inline pa-2">
            <p class="headline mt-3">
                Tramo de mora
                <v-btn class="btn--edit" small @click.prevent="openDialogTranches()">Editar</v-btn>
            </p>
        </div>
        <v-card class="raised">
          <v-card-text>
            <v-layout :class="`${tranche.id < 4 ? 'border--bottom' : 'margin--bottom' }`" 
                row wrap v-for="tranche in tranche_status" :key="tranche.id">
              <v-flex class="subtitle" md4 pr-3>
                <strong>
                  {{ tranche.tranche_status }}
                </strong>
              </v-flex>
              <v-flex class="subtitle indicator" md3 style="text-align: center;">
                >
              </v-flex>
              <v-flex class="subtitle value" md4>
                <div>
                  <div>
                    {{ tranche.mask != null ? tranche.mask : tranche.tranche_status }}
                  </div>  
                </div>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import Edit from '@/components/containment_states/edit';
import EventBus from '@/event-bus';

export default {
  components: {
    Edit,
  },
  data() {
    return {
      deliquency_data: '',
      tranche_data: '',
      field_block_delinquency: 0,
      field_block_tranche: 0,
      dialog: false,
      info: {
        title: '',
      },
    };
  },

  created() {
    this.getDelinquency();
    this.getTranche();
  },

  computed: {
    ...mapGetters(['delinquency_status', 'tranche_status']),
  },

  methods: {
    ...mapActions(['getDelinquency', 'getTranche']),

    updateDeliquency(data) {
      Vue.axios.post('containment-states/create', data).then(() => {
        this.getDelinquency();
      });
    },

    updateTranche(data) {
      Vue.axios.post('containment-tranches/create', data).then(() => {
        this.getTranche();
      });
    },

    openDialogDeliquency() {
      this.dialog = !this.dialog;

      this.info.title = 'Editar Días';
      EventBus.$emit('data_edit_deliquency', this.delinquency_status);
    },

    openDialogTranches() {
      this.dialog = !this.dialog;

      this.info.title = 'Editar Tramos';
      EventBus.$emit('data_edit_tranche', this.tranche_status);
    },

    closeDialog() {
      this.dialog = false;
      this.info.title = '';
    },
  },


};
</script>

<style scoped>

.subtitle {
  padding: 2px 6px;
}
.value {
  text-align: right;
}

.border--bottom {
  padding: 12px 0;
  border-bottom: 1px groove;
}

.margin--bottom {
  padding: 12px 0;
}

.indicator {
  text-align: center;
  font-size: 22px;
  color: #ff7c64;
}

.uncontent {
    font-size: 12px;
}

.btn--edit {
  float: right;
  background-color: #ff7c64 !important;
  border-color: #ff7c64 !important;
  color: #FFF !important;
}
</style>



// WEBPACK FOOTER //
// src/components/containment_states/Index.vue